import "bootstrap/dist/css/bootstrap.min.css";
import { Form  } from "react-bootstrap";
import {
    BadgeColorBox,
    BadgeColorBoxTitle,
    BadgeCheckBoxWrap,
    BadgeCheckForm,
    BadgeCheckBoxMain, 
} from './badgeCheckBoxStyle';

interface BadgeProps{
    setColor:(val:number|string) => void
}
const BadgeCheckBox = ({setColor}:BadgeProps) => {
    return (
    <BadgeColorBox className="base-color">
        <BadgeColorBoxTitle>Badge Color:</BadgeColorBoxTitle>

            <BadgeCheckBoxWrap className="badge-check-box-main">
                <BadgeCheckForm>
                    <BadgeCheckBoxMain className="badge-color-box-radio" >
                        <Form.Check id="orange" type="radio" inline label="Orange" name="group1" defaultChecked className="orange" value={1}  onChange={() => setColor(1)}/>
                        <Form.Check id="green" type="radio" inline label="Green" name="group1" className="green" value={2} onChange={() => setColor(2)}/>
                        <Form.Check id="gray" type="radio" inline label="Gray" name="group1" className="gray" value={3} onChange={() => setColor(3)}/>
                        <Form.Check id="blue" type="radio" inline label="Blue" name="group1" className="blue" value={4} onChange={() => setColor(4)}/>
                    </BadgeCheckBoxMain>
                </BadgeCheckForm>
            </BadgeCheckBoxWrap>
        </BadgeColorBox>
   )
 }

export default BadgeCheckBox